/**
 * Route tree assembly — FROZEN (lead). Each feature owns its own route tree in
 * src/features/<feature>/routes.tsx; add child routes there, not here.
 */
import { createRouter } from '@tanstack/react-router';
import { accountRouteTree } from '../features/account/routes';
import { adminRouteTree } from '../features/admin/routes';
import { authRouteTree } from '../features/auth/routes';
import { caddyRouteTree } from '../features/caddy/routes';
import { clubsRouteTree } from '../features/clubs/routes';
import { platformRouteTree } from '../features/platform/routes';
import { playerRouteTree } from '../features/player/routes';
import { publicRouteTree } from '../features/public/routes';
import { signupRouteTree } from '../features/signup/routes';
import { reportClientError } from '../lib/telemetry';
import { homeRoute } from './home-route';
import { rootRoute } from './root-route';
import { uiKitRoute } from './ui-kit-route';

export const routeTree = rootRoute.addChildren([
  homeRoute,
  authRouteTree,
  adminRouteTree,
  caddyRouteTree,
  publicRouteTree,
  signupRouteTree,
  playerRouteTree,
  clubsRouteTree,
  platformRouteTree,
  accountRouteTree,
  // dev-only UI kit gallery (components/ui/README.md); tree-shaken out of production builds
  ...(import.meta.env.DEV ? [uiKitRoute] : []),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  // route render errors are caught by the router's error component, not by main.tsx's boundary
  defaultOnCatch: (error) => reportClientError('render', error, { source: 'router' }),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
